import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Select from "../../../../../components/Inputs/Select";

export const useSalaryOrHourlyFilter = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      id: "salaryOrHourly",
      Header: t("salary-or-hourly"),
      filter: "select",
      canFilter: true,
      Filter: (
        <Select>
          <Select.Option value="S">{t('salaried')}</Select.Option>
          <Select.Option value="H">{t('hourly')}</Select.Option>
        </Select>
      ),
    }),
    [t]
  );
};
